<template>
  <div class="row mt-2 row-container">
    <div class="col-2 col-sm col-12 border-right status">
      <div class="row">
        <div class="col-6 col-md-12">
          <custom-balloon
            :background-color="getColor(value.monitoringStatusId)"
            class="w-md-80 w-90 mt-2 mx-md-3 font-weight-normal font-16"
            :text="value.status"
          />
        </div>
        <div class="col-5 col-md-0 d-block d-md-none">
          <div class="label">
            Número:
          </div>
          <span class="info">
            {{ value.monitoringNo }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="col-3 col-sm col-12 pl-md-3 pl-md-4 pl-sm-4 mt-4 mt-md-0 mt-sm-4 pt-md-3 d-none d-md-block"
    >
      <div class="label">Número:</div>
      <span class="info">
        {{ value.monitoringNo }}
      </span>
    </div>
    <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-3">
      <div class="label">Fecha:</div>
      <span class="info">
        {{ value.date | date }}
      </span>
    </div>
    <div class="col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-md-3">
      <div class="label">Hallazgo:</div>
      <span class="info">
        {{ value.finding }}
      </span>
    </div>
    <div class="col-12 col-md-2 text-center mt-4 mt-md-0 pr-md-5 pt-md-3">
      <drop-down
        class="actions-dropdown"
        :data-item="{ value, index }"
        :items="actionItems"
      />
    </div>
  </div>
</template>

<script>
import umesrStatus from '@/utils/shared/constants/umesrStatus';
import { Colors } from '@/components/common';
import alertMixin from 'utils/mixins/alert.mixin';
import CustomBalloon from 'custom-balloon';

export default {
  name: 'RowStandard',
  components: {
    CustomBalloon,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
  },
  computed: {
    actionItems() {
      return [
        {
          name: 'goto',
          label: 'Entrar',
          icon: 'fas fa-file-import color-primary-1 pr-1',
          click: this.goToDetail,
          border: 'bottom',
        },
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1 pr-1',
          click: this.goToEditDetail,
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-primary-4 pr-1',
          click: this.onDeleteHandler,
          visible: !this.value.isAutomatic,
        },
      ];
    },
  },
  methods: {
    getColor(status) {
      switch (status) {
        case umesrStatus.reported:
          return Colors.PINK;
        case umesrStatus.approved:
          return Colors.GREEN;
        case umesrStatus.invoiceAdjustment:
          return Colors.YELLOW;
        case umesrStatus.denied:
          return Colors.BROWN;
      }
    },
    goToDetail() {
      this.$router.push({
        name: 'UmesrDetails',
        params: { id: this.value?.studentServiceMonitoringId },
      });
    },
    async onDeleteHandler() {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el hallazgo?',
        'Sí',
        'No'
      );
      if (!answer) {
        return;
      }

      this.$emit('on-delete', this.value?.studentServiceMonitoringId);
    },
    async goToEditDetail() {
      this.$router.push({
        name: 'UmesrDetails',
        params: { id: this.value?.studentServiceMonitoringId, isEditing: true },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.label {
  font-weight: normal;
  font-size: 14px;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-size: 16px;
  color: map-get($colors, 'black');
}

@media only screen and (max-width: 768px) {
  .label {
    font-size: 12px;
  }

  .info {
    font-size: 14px;
  }

  .row-container {
    div,
    span {
      font-size: map-get($fontsSize, 'font-12') !important;
    }
    .status {
      border-right: unset !important;
      border-bottom: 1px solid map-get($colors, 'secondary-12');
      padding-bottom: map-get($fontsSize, 'font-10');
    }
  }

  ::v-deep .reason {
    em {
      font-size: map-get($fontsSize, 'font-10') !important;
    }
    .text-left {
      font-size: map-get($fontsSize, 'font-12') !important;
    }
  }

  .actions-dropdown {
    ::v-deep {
      .dropdown-toggle {
        width: 100%;
        font-size: 12px;
      }
    }
  }
}
</style>
